import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { adminGetDailyActiveUsersApi } from '../../../api/dashboard/adminGetDailyActiveUsersApi';
import { AdminDailyActiveUsersFilter, AdminDailyActiveUsersResponse } from '../../../graphql/API';

export const useAdminGetDailyActiveUsersQuery = (
  filter: AdminDailyActiveUsersFilter,
): UseQueryResult<AdminDailyActiveUsersResponse, Error> => {
  const query = useQuery({
    queryKey: ['admin-get-daily-active-users', filter],
    queryFn: async ({ queryKey }) => {
      const [, filter] = queryKey as [string, AdminDailyActiveUsersFilter];
      const response = await adminGetDailyActiveUsersApi(filter);
      return response;
    },
    enabled: !!filter.fromDate && !!filter.toDate,
  });

  return { ...query };
};
